import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TurnInto = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      ref={forwardedRef}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3125 12.5C8.58864 12.5 8.8125 12.2761 8.8125 12C8.8125 11.7239 8.58864 11.5 8.3125 11.5L6.34375 11.5C5.51532 11.5 4.84375 10.8284 4.84375 10L4.84375 5.20711L6.58395 6.9473C6.77921 7.14257 7.09579 7.14257 7.29105 6.9473C7.48632 6.75204 7.48632 6.43546 7.29105 6.2402L4.6973 3.64645C4.60353 3.55268 4.47636 3.5 4.34375 3.5C4.21114 3.5 4.08396 3.55268 3.9902 3.64645L1.39645 6.2402C1.20118 6.43546 1.20118 6.75204 1.39645 6.9473C1.59171 7.14257 1.90829 7.14257 2.10355 6.9473L3.84375 5.20711L3.84375 10C3.84375 11.3807 4.96304 12.5 6.34375 12.5L8.3125 12.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6875 3.5C7.41136 3.5 7.1875 3.72386 7.1875 4C7.1875 4.27614 7.41136 4.5 7.6875 4.5L9.65625 4.5C10.4847 4.5 11.1562 5.17157 11.1562 6L11.1562 10.7929L9.41605 9.0527C9.22079 8.85743 8.90421 8.85743 8.70895 9.0527C8.51368 9.24796 8.51368 9.56454 8.70895 9.7598L11.3027 12.3536C11.3965 12.4473 11.5236 12.5 11.6563 12.5C11.7889 12.5 11.916 12.4473 12.0098 12.3536L14.6036 9.7598C14.7988 9.56454 14.7988 9.24796 14.6036 9.0527C14.4083 8.85743 14.0917 8.85743 13.8964 9.0527L12.1562 10.7929L12.1562 6C12.1562 4.61929 11.037 3.5 9.65625 3.5L7.6875 3.5Z"
        fill={color}
      />
    </svg>
  )
})

export default TurnInto
